import { forwardRef } from 'react'
import { cn } from '../utils/cn.ts'

export interface GuestListHeaderProps {
  label: string
  count: number
  className?: string
}

export const GuestListHeader = forwardRef<HTMLDivElement, GuestListHeaderProps>(
  ({ label, count, className }, ref) => (
    <div ref={ref} className={cn('guest-list-header', className)}>
      <span className="guest-list-header-label">{label}</span>
      <span className="guest-list-header-count">({count})</span>
    </div>
  ),
)
GuestListHeader.displayName = 'GuestListHeader'
